import Entity from '@/entities/entity'

/*!
 * 用户实体
 */
export default class JasperReport extends Entity<number> {
    tenantId?: number
    client?: string

    reportName?: string
    reportURL?: string

    creationTime?: string
    creatorUserId?: number
    lastModificationTime?: string
    lastModifierUserId?: number

    attribute1?: string
    attribute2?: string
    attribute3?: string
    attribute4?: string
    attribute5?: string
}
